import ms from "ms";
import { makeHook } from "../../utils/makeSingleArgHook";
import getTasks from "../requests/getTasks";
import { tasksUrl } from "../requests/urls";
export function tasksKeyMaker(queryParams) {
    if (queryParams === null) {
        return [tasksUrl("v1")];
    }
    return [tasksUrl("v1"), JSON.stringify(queryParams)];
}
const useGetTasks = makeHook(async (queryParams, auth) => getTasks(auth, queryParams), (queryParams) => tasksKeyMaker(queryParams), { staleTime: ms("1minute") });
export default useGetTasks;
//# sourceMappingURL=useGetTasks.js.map